import { useMatch, type PathPattern } from 'react-router-dom';

export type SettingsResourceLayoutLabels = {
    list: string;
    create: string;
    edit: string;
};

export type UseSettingsResourceLayoutArgs = {
    createPath: PathPattern;
    editPath: PathPattern;
    /** `Content` `backNavLink` when create or edit route is active */
    listBackPath: string;
    labels: SettingsResourceLayoutLabels;
};

/**
 * List / create / edit settings screens wrapped in `Content`: stable `useMatch` branches
 * (avoids `pathname.includes('edit')`) plus back link to the settings list vs `/settings`.
 */
export function useSettingsResourceLayout({ createPath, editPath, listBackPath, labels }: UseSettingsResourceLayoutArgs) {
    const createMatch = useMatch({ ...createPath, end: true });
    const editMatch = useMatch({ ...editPath, end: true });
    const inFormContext = Boolean(createMatch || editMatch);

    return {
        headerTitle: editMatch ? labels.edit : createMatch ? labels.create : labels.list,
        backNavLink: inFormContext ? listBackPath : '/settings',
    };
}
